import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { MerchCardShadowColumns } from 'pricing-pages-ui-components/components/MerchCardShadowColumns';
import { FreeToolsMerchCard } from '../../containers/FreeToolsMerchCard';
import { HubMerchCard } from '../../containers/merch-card/cards/HubMerchCard';
import { SuiteFeatures } from '../../containers/merch-card/features-display/SuiteFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FreeToolsMerchCards = () => {
  return /*#__PURE__*/_jsx(View, {
    position: "relative",
    marginBlockEnd: "800",
    children: /*#__PURE__*/_jsxs(MerchCardShadowColumns, {
      columns: 2,
      isUngatedForInbound25: true,
      children: [/*#__PURE__*/_jsx(FreeToolsMerchCard, {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.customerPlatform.freeCard.title"
        }),
        HubDescription: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.customerPlatform.freeCard.description"
        }),
        Features: /*#__PURE__*/_jsx(SuiteFeatures, {
          productLevel: "FREE",
          loading: false,
          isCollapsible: false
        }),
        trackingSource: "free-card"
      }), /*#__PURE__*/_jsx(HubMerchCard, {
        apiName: "crm-suite-starter-bundle",
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.customerPlatform.starterCard.title"
        }),
        HubDescription: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.customerPlatform.starterCard.description"
        }),
        Features: /*#__PURE__*/_jsx(SuiteFeatures, {
          productLevel: "STARTER",
          loading: false,
          isCollapsible: false
        })
      })]
    })
  });
};